module.exports = __webpack_public_path__ + "static/img/Taurus.a8a41c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/zodiac_image/Taurus.svg
// module id = 1404
// module chunks = 0